import { BaseViewStore } from 'core/stores';
import { action, makeObservable, observable } from 'mobx';
import _ from 'lodash';
import { SyncInventoryForSellerForm } from '../forms';
import { ProductInventoryStore } from 'modules/product-inventory/stores';
import { isSome } from 'core/utils';
import { BaasicDropdownViewStore } from 'common/stores';
import { ApplicationStore } from 'platform/application/stores';
import { isSuperAdminOrganization } from 'core/utils';

class SyncInventoryForSellerViewStore extends BaseViewStore {
	@observable isSyncing = false;
	@observable sellerDropdownStore = null;

	form = new SyncInventoryForSellerForm({
		onSuccess: async () => {
			await this.syncInventory();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.data = modalParams && modalParams.data ? modalParams.data : null;
		this.productInventoryStore = new ProductInventoryStore(this.rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		this.isSuperAdminOrganization = isSuperAdminOrganization(this.rootStore);
		this.sellerDropdownStore = new BaasicDropdownViewStore();
		await this.sellerDropdownStore.initialize({
			field: this.form.$('sellerId'),
			value: this.isSuperAdminOrganization ? this.rootStore.viewStore.sellerDropdownStore.value : this.rootStore.applicationStore.currentOrganization,
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				sellerOnly: true,
				embed: ['organizationType'],
			},
		});
		this.resume();
	};

	@action.bound
	syncInventory = async () => {
		if (this.isSyncing) return;
		this.isSyncing = true;
		const sellerId = isSome(this.sellerDropdownStore.value) ? this.sellerDropdownStore.value.value : null;
		const result = await this.productInventoryStore.syncInventoryForSeller(
			{ sellerId },
			'Inventory List - Sync Inventory'
		);
		if (result.statusCode === 200) {
			if (result.data.status === 'Fail') {
				this.rootStore.notificationStore.error(`${result.data.errors[0]}`);
			} else if (result.data.status === 'Partial') {
				this.rootStore.notificationStore.warning(`${result.data.errors[0]}`);
			} else {
				this.rootStore.notificationStore.success('Inventory Sync Successful.');
			}
		} else {
			this.rootStore.notificationStore.error('Inventory Sync Failed.');
		}
		this.isSyncing = false;
	};
}

export default SyncInventoryForSellerViewStore;
